import { useState, useEffect, useRef, createContext } from 'react';
import { FaMicrophone, FaSearch, FaArrowAltCircleDown } from "react-icons/fa";
import { IoSend, IoClose } from "react-icons/io5";
import { MdKeyboardVoice } from "react-icons/md";
import { IoMdAttach } from "react-icons/io";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FaChartArea } from "react-icons/fa6";
import { AiFillFilePdf } from "react-icons/ai";
import { BsFillFileEarmarkSpreadsheetFill } from "react-icons/bs";
// import PdfViewer from './PdfViewer';
// import Image from 'next/image';
import { MdLayersClear } from "react-icons/md";
import ExcelJS from "exceljs";
import { sendRasaMessage, uploadContentDoc } from './ChatApi.jsx';
import { useAISearch } from './AISearchContext.tsx';
import { ChemPluginPanel } from '../ChemPlugin/ChemPluginPanel.tsx';
import { Beaker } from 'lucide-react';
export const OpenOrderContext = createContext({});
const ChatBot = ({ t, ordersDetails, spreadsheetRef }) => {
    const [popup, setPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [messages, setMessages] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [recording, setRecording] = useState(false);
    const [uploadedImage, setUploadedImage] = useState(null);
    const [attachView, setAttachView] = useState(false);
    const inputRef = useRef(null);
    const messagesEndRef = useRef(null);
    const chatContainerRef = useRef(null);
    const [page, setPage] = useState([])
    const chemPluginRef = useRef(null);
    const [isChemPluginOpen, setIsChemPluginOpen] = useState(false);
    // const { t } = props;
    const { setAiSearchData, setAiScreenData } = useAISearch();
    const [filenames, setFilenames] = useState([]);
    const [selectedFilename, setSelectedFilename] = useState("");
    const [position, setPosition] = useState({ x: 20, y: 20 });
    const dragData = useRef({
        dragging: false,
        startX: 0,
        startY: 0,
        moved: false
    });

    const handleMouseDown = (e) => {
        e.preventDefault();
        dragData.current.dragging = true;
        dragData.current.moved = false;
        dragData.current.startX = e.clientX;
        dragData.current.startY = e.clientY;

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseMove = (e) => {
        if (!dragData.current.dragging) return;

        const dx = Math.abs(e.clientX - dragData.current.startX);
        const dy = Math.abs(e.clientY - dragData.current.startY);

        if (dx > 3 || dy > 3) {
            dragData.current.moved = true;
        }

        const winWidth = window.innerWidth;
        const winHeight = window.innerHeight;

        const newX = winWidth - e.clientX - 30;
        const newY = winHeight - e.clientY - 30;

        setPosition({
            x: Math.max(0, Math.min(newX, winWidth - 60)),
            y: Math.max(0, Math.min(newY, winHeight - 60))
        });
    };

    const handleMouseUp = () => {
        dragData.current.dragging = false;

        // Reset `moved` shortly after drag ends
        setTimeout(() => {
            dragData.current.moved = false;
        }, 50);

        window.removeEventListener("mousemove", handleMouseMove);
        window.removeEventListener("mouseup", handleMouseUp);
    };

    const handleClick = () => {
        if (!dragData.current.moved) {
            setPopup(true);
        }
    };
    const handlePdfAnalysis = async (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("folderId", 1);
        formData.append("userCode", 1)

        try {
            setMessages((prev) => [
                ...prev,
                { text: `Uploading ${file.name} ...`, sender: "user" }
            ]);
            setLoading(true);

            const result = await uploadContentDoc(formData);
            fetchDocuments();
            setSelectedFilename(file.name);

            setMessages((prev) => [
                ...prev,
                { text: `${file.name} uploaded successfully.`, sender: "bot" }
            ]);
        } catch (error) {
            console.error("Error uploading PDF:", error);
            alert("PDF upload failed: " + error.message);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (loading) {
            setAttachView(false)
        }

    }, [loading])
    const fetchDocuments = async () => {
        try {
            // const docs = await fetchAllDocuments();
            // setFilenames(docs);
            setFilenames([])
        } catch (err) {
            console.error("Failed to fetch documents:", err);
        }
    };
    useEffect(() => {
        fetchDocuments();
    }, []);

    const handleChange = (e) => {
        const newFilename = e.target.value;
        setSelectedFilename(newFilename);
        console.log("Selected filename in handleChange:", newFilename);
    };

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Enter' && !loading) {
                handleSendMessage();
            }
            // if (event.code === 'Space' && document.activeElement.tagName !== 'INPUT') {
            //     event.preventDefault();
            //     setPopup(prev => !prev);
            // }
            if (event.ctrlKey && event.key === 'ArrowLeft') handleMicClick();
            if (event.key === 'ArrowDown' && popup) {
                event.preventDefault();
                inputRef.current?.focus();
            } else if (event.key === 'ArrowUp' && popup) {
                event.preventDefault();
                inputRef.current?.blur();
            }
        };

        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [loading, popup, selectedFilename]);


    useEffect(() => {
        scrollToBottom();
    }, [messages]);

    const scrollToBottom = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
        setScroll(false);
    };

    const handleScroll = () => {
        const container = chatContainerRef.current;
        if (container) {
            const isAtBottom = Math.round(container.scrollHeight - container.scrollTop) === Math.round(container.clientHeight);
            setScroll(!isAtBottom);
        }
    };

    useEffect(() => {
        if (loading) {
            setAttachView(false);
        }
    }, [loading]);

    const handleAttach = () => {
        setAttachView(!attachView);
    };

    const handleCloseAttach = () => {
        if (attachView) {
            setAttachView(false);
        }
    };


    const handleSendMessage = async (message = "", imageOverride = null, filenameOverride = null) => {
        const userMessage = inputRef.current?.value.trim() || message.trim();
        const imageToSend = imageOverride || uploadedImage;

        const filenameToUse = filenameOverride || selectedFilename;

        if (!userMessage && !imageToSend) return;

        if (!imageOverride) {
            setMessages((prev) => [
                ...prev,
                { text: userMessage || "📷 Image attached", sender: "user" },
            ]);
        }

        setLoading(true);
        setScroll(true);

        try {
            const { botReply, aisearch_data, aiscreen_data, aimultiscreen_data, aimultioption_data, aiimage_data, aispread_data, aipage_data } =
                await sendRasaMessage({
                    message: userMessage,
                    image: imageToSend,
                    filename: filenameToUse,
                });
            console.log('Filename sent to Rasa:', filenameToUse);
            console.log('Current selectedFilename state:', selectedFilename);

            if (aipage_data) {
                setPage(aipage_data)
                setMessages((prev) => [...prev, { text: "Documents Updated", sender: "bot" }]);
                // setMessages((prev) => [
                //     ...prev,
                //     {
                //         // text: botReply || "📄 Page data retrieved successfully",
                //         sender: "bot",
                //         aipage_data: aipage_data,
                //     },
                // ]);
            } else if (aiimage_data) {
                console.log("aiimage_data", aiimage_data);
                setMessages((prev) => [
                    ...prev,
                    {
                        text: "📊 Image parsed successfully",
                        sender: "bot",
                        aiimage_data: aiimage_data,
                    },
                ]);
            } else if (aispread_data) {
                console.log("aispread_data", aispread_data);
                setMessages((prev) => [
                    ...prev,
                    {
                        text: botReply || "📈 Spreadsheet data processed successfully",
                        sender: "bot",
                        aispread_data: aispread_data,
                    },
                ]);
                // setAiSearchData([]);
                setAiScreenData(null);
            } else if (aimultioption_data && aimultioption_data.length > 0) {
                setMessages((prev) => [
                    ...prev,
                    {
                        text: botReply || `Please choose an option for "${userMessage}":`,
                        sender: "bot",
                        buttons: aimultioption_data.map((option) => ({
                            title: option,
                            payload: option,
                        })),
                    },
                ]);
                // setAiSearchData([]);
                setAiScreenData(null);
            } else if (aimultiscreen_data && aimultiscreen_data.length > 0) {
                setMessages((prev) => [
                    ...prev,
                    {
                        text: botReply || "Please choose one of the following screens:",
                        sender: "bot",
                        buttons: aimultiscreen_data.map((screenName) => ({
                            title: screenName.smenuname,
                            payload: `Navigate ${screenName.smenuname}`,
                        })),
                    },
                ]);
                // setAiSearchData([]);
                setAiScreenData(null);
            } else if (aisearch_data) {
                setAiSearchData(aisearch_data);
                setMessages((prev) => [...prev, { text: botReply || "Documents Updated", sender: "bot" }]);
                setAiScreenData('ChatBot');
                setTimeout(() => {
                    setAiScreenData(null);
                }, 500);
            } else if (aiscreen_data) {
                // setAiSearchData([]);
                setAiScreenData(aiscreen_data);
                setMessages((prev) => [...prev, { text: botReply || "Screen updated.", sender: "bot" }]);
                setTimeout(() => {
                    setAiScreenData(null);
                }, 500);

            } else {
                setMessages((prev) => [...prev, { text: botReply, sender: "bot" }]);
                // setAiSearchData([]);
                setAiScreenData(null);
            }
        } catch (error) {
            console.error("Error in handleSendMessage:", error);
            setMessages((prev) => [
                ...prev,
                { text: "Sorry, I don't understand your question or an error occurred.", sender: "bot" },
            ]);
            // setAiSearchData([]);
            setAiScreenData(null);
        } finally {
            setLoading(false);
            if (inputRef.current) inputRef.current.value = "";
            setUploadedImage(null);
            scrollToBottom();
            setAiSearchData(messages);
        }
    };

    const handleMicClick = () => {
        setRecording(true);
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert("Speech Recognition is not supported in this browser.");
            setRecording(false);
            return;
        }

        const recognition = new SpeechRecognition();
        recognition.lang = "en-US";
        recognition.interimResults = false;
        recognition.maxAlternatives = 1;

        let silenceTimer = null;

        recognition.onstart = () => {
            const initialMessage = "Hi, I am Rasa";
            const speech = new SpeechSynthesisUtterance(initialMessage);
            speech.lang = "en-US";
            window.speechSynthesis.speak(speech);

            silenceTimer = setTimeout(() => {
                recognition.stop();
                setLoading(false);
            }, 5000);
        };

        recognition.onresult = (event) => {
            clearTimeout(silenceTimer);
            const speechText = event.results[0][0].transcript;
            setRecording(false);
            handleSendMessage(speechText);
        };

        recognition.onerror = (event) => {
            clearTimeout(silenceTimer);
            setRecording(false);
            console.error("Speech recognition error:", event.error);
            setMessages((prev) => [
                ...prev,
                { text: "Speech recognition error. Please try again.", sender: "bot" },
            ]);
        };

        recognition.onend = () => {
            clearTimeout(silenceTimer);
            setRecording(false);
        };

        recognition.start();
    };

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        const reader = new FileReader();
        reader.onload = () => {
            const imageDataUrl = reader.result;

            setMessages((prev) => [
                ...prev,
                {
                    text: "📷 Image attached",
                    sender: "user",
                    image: imageDataUrl,
                },
            ]);

            handleSendMessage("Read the image", file);
        };
        reader.readAsDataURL(file);
        event.target.value = "";
    };

    const handlePdfUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setMessages((prev) => [
            ...prev,
            {
                text: "📄 PDF attached",
                sender: "user",
                fileName: file.name,
            },
        ]);

        handleSendMessage("analysis the spreadsheet", file);
        event.target.value = "";
    };

    const handleButtonClick = (payload) => {
        handleSendMessage(payload);
    };

    // const exportExcel = (aispread_data, filename) => {
    //     const sheet = aispread_data.sheets?.[0];
    //     if (!sheet || !sheet.rows) return;

    //     const aoa = sheet.rows.map(row =>
    //         row.cells.map(cell => cell.value)
    //     );

    //     const worksheet = XLSX.utils.aoa_to_sheet(aoa);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name || 'Sheet1');
    //     XLSX.writeFile(workbook, `${filename}.xlsx`);
    // };
    const exportExcel = async (aispread_data, filename) => {
        const sheetData = aispread_data.sheets?.[0];
        if (!sheetData || !sheetData.rows) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(sheetData.name || "Sheet1");

        sheetData.rows.forEach((row, rIdx) => {
            const excelRow = worksheet.getRow(rIdx + 1);
            row.cells.forEach((cell, cIdx) => {
                const excelCell = excelRow.getCell(cIdx + 1);

                excelCell.value = cell.value || "";

                // Font
                excelCell.font = {
                    name: cell.fontFamily || "Arial",
                    size: cell.fontSize || 12,
                    bold: cell.bold || false,
                    color: { argb: (cell.color || "#000000").replace("#", "") },
                };

                // Alignment
                excelCell.alignment = {
                    horizontal: cell.textAlign || "center",
                    vertical: "middle",
                };

                // Fill (background)
                excelCell.fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: (cell.background || "#FFFFFF").replace("#", "") },
                };

                // Borders
                excelCell.border = {
                    top: cell.borderTop
                        ? { style: "thin", color: { argb: (cell.borderTop.color || "#000000").replace("#", "") } }
                        : undefined,
                    bottom: cell.borderBottom
                        ? { style: "thin", color: { argb: (cell.borderBottom.color || "#000000").replace("#", "") } }
                        : undefined,
                    left: cell.borderLeft
                        ? { style: "thin", color: { argb: (cell.borderLeft.color || "#000000").replace("#", "") } }
                        : undefined,
                    right: cell.borderRight
                        ? { style: "thin", color: { argb: (cell.borderRight.color || "#000000").replace("#", "") } }
                        : undefined,
                };
            });
            excelRow.commit();
        });

        // Export file in browser
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${filename}.xlsx`;
        link.click();
    };
    const exportJSON = (data, filename) => {
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
    };

    return (
        <>
            {popup ? (
                <div className="chat-popup">
                    <div className='linear'>
                        <img src='/images/chatbot/chat1.jpg' alt='icon' style={{ height: 35, width: 35, borderRadius: '50%', padding: 2, backgroundColor: 'white' }} />
                        <h5 className='chat-title'>{t("Orders.Sheetorders.IDS_LBL_AGARAMBOT")}</h5>
                        <button className='close_button' onClick={() => setMessages([])}>
                            <MdLayersClear className='close_button1' />
                        </button>
                        <button className='close_button' onClick={() => setPopup(false)}>
                            <IoClose className='close_button1' />
                        </button>
                    </div>

                    <div className='chat-popup-box d-flex flex-column' onClick={handleCloseAttach}>
                        {!recording && !loading && messages.length === 0 && (
                            <div className="chat-center">
                                <img src='/images/chatbot/chatbg.png' alt='chat icon' style={{ height: 60, width: 60, margin: 5, opacity: 0.4 }} />
                                <h6 className='text-center' style={{ opacity: 0.4, fontSize: '16px' }}>
                                    {t("IDS_HELLOTHERE")}  <br />  {t("IDS_ASSISTQUESTION2")}
                                </h6>
                            </div>
                        )}

                        {loading && messages.length === 0 && (
                            <img src='/images/chatbot/Load2.gif' alt="Loading..." style={{ height: 50, width: 50 }} />
                        )}

                        {recording && (
                            <div className="recording">
                                <div className="mic-button">
                                    <MdKeyboardVoice className="mic-icon" />
                                </div>
                            </div>
                        )}

                        {!recording && messages.length !== 0 && (
                            <div
                                className="chat-messages"
                                ref={chatContainerRef}
                                onScroll={handleScroll}
                                style={{ overflowY: 'auto', maxHeight: '400px' }}
                            >
                                {messages.map((msg, index) => (
                                    <div key={index} className={`message ${msg.sender}`}>
                                        <div className="message-text">{msg.text}</div>

                                        {msg.image && (
                                            <img
                                                src={msg.image}
                                                alt="Uploaded"
                                                className="message-image"
                                                style={{ maxWidth: '200px', marginTop: 8, borderRadius: 8 }}
                                            />
                                        )}
                                        {msg.aiimage_data && (
                                            <div className="chart-block">
                                                <h4 className="chart-title">
                                                    {msg.aiimage_data.title || msg.aiimage_data.raw?.title || 'Graph Data'}
                                                </h4>
                                                {(() => {
                                                    const tableData =
                                                        msg.aiimage_data.data?.length > 0
                                                            ? msg.aiimage_data.data
                                                            : msg.aiimage_data.raw?.dataPoints ||
                                                            msg.aiimage_data.raw?.data_points ||
                                                            msg.aiimage_data.dataPoints ||
                                                            msg.aiimage_data.data_points ||
                                                            [];
                                                    return tableData.length > 0 ? (
                                                        <DataTable value={tableData} className="chart-table">
                                                            {Object.keys(tableData[0]).map((key) => (
                                                                <Column
                                                                    key={key}
                                                                    field={key}
                                                                    header={key.charAt(0).toUpperCase() + key.slice(1)}
                                                                />
                                                            ))}
                                                        </DataTable>
                                                    ) : (
                                                        <div className="chart-table">{t("IDS_NOAVAILABLEOPTIONS")}</div>
                                                    );
                                                })()}
                                                <button
                                                    onClick={() =>
                                                        exportJSON(
                                                            msg.aiimage_data.raw || msg.aiimage_data,
                                                            `${(msg.aiimage_data.title || 'data').replace(/\s+/g, '_').toLowerCase()}.json`
                                                        )
                                                    }
                                                    className="chart-export-btn"
                                                >
                                                    Export JSON
                                                </button>
                                            </div>
                                        )}

                                        {msg.aispread_data && (
                                            <div className="spreadsheet-block">
                                                <h4 className="spreadsheet-title">
                                                    {msg.aispread_data.title || 'Spreadsheet Data'}
                                                </h4>
                                                <button
                                                    onClick={() =>
                                                        exportJSON(
                                                            msg.aispread_data.raw || msg.aispread_data,
                                                            `${(msg.aispread_data.title || 'spreadsheet').replace(/\s+/g, '_').toLowerCase()}.json`
                                                        )
                                                    }
                                                    className="chart-export-btn"
                                                >
                                                    Export JSON
                                                </button>
                                                <button className="chart-export-btn" onClick={() => exportExcel(msg.aispread_data, 'Spread_sheet_analysis')}>
                                                    Export Excel
                                                </button>
                                            </div>
                                        )}

                                        {msg.buttons && (
                                            <div className="message-buttons">
                                                {msg.buttons.map((button, btnIndex) => (
                                                    <button
                                                        key={btnIndex}
                                                        onClick={() => handleButtonClick(button.payload)}
                                                        className="chat-button"
                                                    >
                                                        {button.title}
                                                    </button>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                ))}

                                {loading && (
                                    <img src='/images/chatbot/Load2.gif' alt="Loading..." style={{ height: 50, width: 50 }} />
                                )}
                                {scroll && (
                                    <button onClick={scrollToBottom} className="scroll-to-bottom-btn">
                                        <FaArrowAltCircleDown style={{ fontSize: 20, margin: 2 }} />
                                    </button>
                                )}
                                <div ref={messagesEndRef} />
                            </div>
                        )}
                    </div>

                    <div className="chat-popup-input" style={{ border: 'none' }}>
                        <select
                            className="chat-drop-down"
                            value={selectedFilename}
                            onChange={handleChange}
                        >
                            <option value="">{t("IDS_SELECTPDF")}</option>
                            {filenames.map((name, idx) => (
                                <option key={idx} value={name}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="chat-popup-input">
                        <div className="input-wrapper">
                            <FaSearch className="search-icon" />
                            <input
                                type="text"
                                ref={inputRef}
                                placeholder="Type your message..."
                            />
                        </div>
                        <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => handlePdfAnalysis(e)}
                            style={{ display: 'none' }}
                            id="pdfanalysis"
                        />
                        <input
                            type="file"
                            accept="image/*"
                            onChange={(e) => handleImageUpload(e)}
                            style={{ display: 'none' }}
                            id="imageUpload"
                        />
                        <input
                            type="file"
                            accept=".pdf, .xlsx, .xls"
                            onChange={(e) => handlePdfUpload(e)}
                            style={{ display: 'none' }}
                            id="pdfUpload"
                        />

                        {attachView && !loading && (
                            <ul className="attach-list">
                                <li className="attach-list-elements">
                                    <label htmlFor="imageUpload"><FaChartArea style={{ fontSize: 20 }} className='icon-chart' /> {t("IDS_GRAPHANALYSIS")}</label>
                                </li>
                                <li className="attach-list-elements">
                                    <label htmlFor="pdfanalysis"><AiFillFilePdf style={{ fontSize: 25 }} /> {t("IDS_PDFANALYSIS")}</label>
                                </li>
                                <li className="attach-list-elements">
                                    <label htmlFor="pdfUpload"><BsFillFileEarmarkSpreadsheetFill style={{ fontSize: 25 }} /> {t("IDS_SPREADSHEETANALYSIS")}</label>
                                </li>
                            </ul>
                        )}
                        {!isChemPluginOpen && <button onClick={() => { setIsChemPluginOpen(!isChemPluginOpen); setPopup(false) }} class="ChemicalIcon border-0 " title='Chemistry Plugin'>
                            <Beaker size={24} /> </button>
                        }
                        <button onClick={handleAttach} disabled={loading} className='Attachementicon' title='Add Attachment'>
                            <IoMdAttach />
                        </button>
                        <button onClick={handleMicClick} disabled={loading} className='Microphone' title='Microphone'>
                            <FaMicrophone />
                        </button>
                        <button onClick={() => handleSendMessage()} disabled={loading} className='MessageSend' title='Send Message'>
                            <IoSend />
                        </button>
                    </div>
                </div>
            ) : (
                <img
                    className="chat-popup-button"
                    onClick={handleClick}
                    src="/images/chatbot/mylogo.png"
                    alt="chat icon"
                    style={{
                        height: 60,
                        width: 60,
                        position: "fixed",
                        bottom: position.y,
                        right: position.x,
                        cursor: "grab",
                        zIndex: 9999
                    }}
                    onMouseDown={handleMouseDown}
                />
            )}
            {isChemPluginOpen &&
                < div style={styles.pluginArea}>
                    <OpenOrderContext.Provider value={{ OpnedOrder: ordersDetails }}>
                        <ChemPluginPanel
                            ref={chemPluginRef}
                            experimentId={"chemPlugin"}
                            isOpen={isChemPluginOpen}
                            onStateChange={() => { }}
                            onToggle={() => { setIsChemPluginOpen(!isChemPluginOpen); setPopup(true) }}
                        />
                    </OpenOrderContext.Provider>
                </div >
            }

        </>
    );

}

const styles = {
    layout: {
        display: 'flex',
        width: '100%',
        height: '100vh',
        position: 'relative',
    },
    mainArea: {
        flex: 1,
        position: 'relative',
        overflow: 'auto',
        backgroundColor: '#f9fafb',
    },
    pluginArea: {
        position: 'relative',
        zIndex: 1000, // Match panel z-index
    },
    chemToggleHint: {
        position: 'fixed',
        bottom: '100px',
        right: '20px',
        maxWidth: '300px',
        padding: '12px 16px',
        backgroundColor: '#fef3c7',
        border: '1px solid #fbbf24',
        borderRadius: '8px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        zIndex: 30,
    },
    hintText: {
        margin: 0,
        fontSize: '13px',
        color: '#78350f',
        lineHeight: '1.5',
    },
};
export default ChatBot